import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  SUPPORT_CREATE_USER_AND_SUBSCRIPTION_CALLCENTER_ONBOARDING_BEGIN,
  SUPPORT_CREATE_USER_AND_SUBSCRIPTION_CALLCENTER_ONBOARDING_SUCCESS,
  SUPPORT_CREATE_USER_AND_SUBSCRIPTION_CALLCENTER_ONBOARDING_FAILURE,
  SUPPORT_CREATE_USER_AND_SUBSCRIPTION_CALLCENTER_ONBOARDING_DISMISS_ERROR,
} from './constants';
import config from '../../../common/config';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';
import axios from 'axios';

export function createUserAndSubscriptionCallcenterOnboarding(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: SUPPORT_CREATE_USER_AND_SUBSCRIPTION_CALLCENTER_ONBOARDING_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${config.apiRootUrl}/users/create-user-callcenter-onboarding/`,
        args,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: SUPPORT_CREATE_USER_AND_SUBSCRIPTION_CALLCENTER_ONBOARDING_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: SUPPORT_CREATE_USER_AND_SUBSCRIPTION_CALLCENTER_ONBOARDING_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateUserAndSubscriptionCallcenterOnboardingError() {
  return {
    type: SUPPORT_CREATE_USER_AND_SUBSCRIPTION_CALLCENTER_ONBOARDING_DISMISS_ERROR,
  };
}

export function useCreateUserAndSubscriptionCallcenterOnboarding() {
  const dispatch = useDispatch();

  const {
    createUserAndSubscriptionCallcenterOnboardingPending,
    createUserAndSubscriptionCallcenterOnboardingError,
  } = useSelector(
    (state) => ({
      createUserAndSubscriptionCallcenterOnboardingPending:
        state.support.createUserAndSubscriptionCallcenterOnboardingPending,
      createUserAndSubscriptionCallcenterOnboardingError:
        state.support.createUserAndSubscriptionCallcenterOnboardingError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(createUserAndSubscriptionCallcenterOnboarding(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(
      dismissCreateUserAndSubscriptionCallcenterOnboardingError(),
    );
  }, [dispatch]);

  return {
    createUserAndSubscriptionCallcenterOnboarding: boundAction,
    createUserAndSubscriptionCallcenterOnboardingPending,
    createUserAndSubscriptionCallcenterOnboardingError,
    dismissCreateUserAndSubscriptionCallcenterOnboardingError:
      boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SUPPORT_CREATE_USER_AND_SUBSCRIPTION_CALLCENTER_ONBOARDING_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        createUserAndSubscriptionCallcenterOnboardingPending: true,
        createUserAndSubscriptionCallcenterOnboardingError: null,
      };

    case SUPPORT_CREATE_USER_AND_SUBSCRIPTION_CALLCENTER_ONBOARDING_SUCCESS:
      // The request is success
      return {
        ...state,
        createUserAndSubscriptionCallcenterOnboardingPending: false,
        createUserAndSubscriptionCallcenterOnboardingError: null,
      };

    case SUPPORT_CREATE_USER_AND_SUBSCRIPTION_CALLCENTER_ONBOARDING_FAILURE:
      // The request is failed
      return {
        ...state,
        createUserAndSubscriptionCallcenterOnboardingPending: false,
        createUserAndSubscriptionCallcenterOnboardingError: action.data.error,
      };

    case SUPPORT_CREATE_USER_AND_SUBSCRIPTION_CALLCENTER_ONBOARDING_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        createUserAndSubscriptionCallcenterOnboardingError: null,
      };

    default:
      return state;
  }
}
